import BaseService from './BaseService'

class WorkflowsResellingService extends BaseService {
  PRODUCT_ID = 'starter_plus_workflow_premium_actions_triggers'

  constructor(baseUrl: string) {
    super(baseUrl)
  }

  get productId() {
    return this.PRODUCT_ID
  }

  getProductConfiguration = () => this.requests.get(`/product?productCode=${this.PRODUCT_ID}`)

  getCompanyResellingConfig = (companyId: string) =>
    this.requests.get(`/configuration/company/${companyId}/${this.PRODUCT_ID}`)

  updateCompanyResellingConfig = (
    companyId: string,
    data: { amount?: number; offeringEnabled?: boolean; plans?: { planId: string; amount: number }[] }
  ) => this.requests.put(`/configuration/company/${companyId}/${this.PRODUCT_ID}`, data)

  getLocationConfig = (locationId: string) =>
    this.requests.get(`/configuration/location/${locationId}/${this.PRODUCT_ID}`)

  getLocationSubscriptions = (locationId: string) =>
    this.requests.get(`/subscription/location/${locationId}?paymentStatus=COMPLETE`)

  updateLocationResellingConfig = (
    locationId: string,
    data: { amount?: number; offeringEnabled?: boolean; plans?: { planId: string; amount: number }[] }
  ) => this.requests.put(`/configuration/location/${locationId}/${this.PRODUCT_ID}`, data)

  agencyDirectPurchase = (locationId: string, planId: string) =>
    this.requests.post(`/subscription/location/${locationId}/${this.PRODUCT_ID}`, {
      purchaseStyle: 'COMPANY_DIRECT_PURCHASE',
      planId,
    })

  getCompanySubscriptions = (companyId: string) => this.requests.get(`/subscription/company/${companyId}`)
}

const instance = new WorkflowsResellingService(BaseService.servicesConfig.Reselling as string)

export default instance
